module.exports = __webpack_public_path__ + "img/KV@2x.679096d6.png";